export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-course-head.vue?vue&type=template&id=13a5f7d2&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-course/lk-course-head/lk-course-head.vue?vue&type=template&id=13a5f7d2&
// module id = 1497
// module chunks = 0